export enum RentalRequestStatus {
  Pending = 0,
  Confirmed = 1,
  Rejected = 2,
  Completed = 3
}

export const RentalRequestStatusLabels: Record<RentalRequestStatus, string> = {
  [RentalRequestStatus.Pending]: "Ausstehend",
  [RentalRequestStatus.Confirmed]: "Bestätigt",
  [RentalRequestStatus.Rejected]: "Abgelehnt",
  [RentalRequestStatus.Completed]: "Abgeschlossen"
};
